export default __webpack_public_path__ + "static/media/share.50a1309b.svg";